import React, { Component } from 'react';
import { Card } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.css';
import './Form.css'

class Success extends Component {
    state= {
    }

    render(){
        return (
            <div style={{display:'flex', justifyContent: 'center', alignContent: 'center', alignItems: 'center', flexDirection: 'column'}} className="errorPage">
                <Card className="p-4 shadow lw-card">
                    <Card.Body>
                    <Card.Title style={{textAlign: 'center'}}> Thank you for signing up.</Card.Title>
                    <hr />
                    <Card.Subtitle className="text-muted" style={{textAlign: 'center'}}> Your subscription to our sms newsletter is complete, you can text STOP to opt-out at any time.</Card.Subtitle>
                    </Card.Body>
                </Card>
            </div>
        )
    }
}

export default Success;